export const invoiceFormData = () => ({
  inputData: {
    project_id: null,
    order_id: null,
    invoice_no: null,
    warehouse_id: null,
    gst_no: "",
    order_date: "",
    invoice_date: "",
    address: "",
    remark: "",
    created_by: 1,
    updated_by: 1,
    is_active: true,

    invoice_order_items: [
      {
        forceSave: true,
        item_id: null,
        forceSave: true,
        item_code: null,
        qty: null,
        invoce_qty: null,
        unit_rate: null,
        amount: null,
        inward_qty: null,
        is_active: true,
        buy_item_details: [
          {
            item_id: null,
            item_code: null,
            item_desc: null,
            uom: null,
            qty: null,
          },
        ],
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "invoices",
    whereCondition: {
      is_active: true,
    },
    relation: [
      {
        modelName: "invoice_order_items",
        moduleAs: "invoice_order_items",
      },
    ],
  };

  const navigatePage = { back: "/invoice-list" };

  const headerName = "Invoice";

  const validationType = "InvoiceCreate";
  const createEndpoint = "/createInvoice";
  const getEndpoint = "/getInvoiceById";

  const stageOptions = [
    { label: "Inward", value: 1 },
    { label: "Outward", value: 2 },
    { label: "Installation", value: 3 },
    { label: "Commissioning", value: 4 },
  ];

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    stageOptions,
  };
};

export const exportPageData = {
  data: {
    modelName: "invoices",

    relations: [
      {
        module: "invoice_order_items",
        moduleAs: "invoice_order_items",
        subModule: "item_masters",
        subModuleAs: "item",
        subSubModule: "uom_masters",
        subSubModuleAs: "uom",
      },
      {
        module: "projects",
        moduleAs: "project",
      },
      {
        module: "orders",
        moduleAs: "order",
      },
    ],
    search: {
      searchKeyword: "",
      field_name: [
        "invoice_no",
        "project.project_code",
        "project.project_name",
        "order.order_no",
      ],
    },
    pagination: { page: 1, pageSize: 10000 },
  },
  fileName: "invoiceData.xlsx",
};
